import { render, staticRenderFns } from "./CurrentOrder.vue?vue&type=template&id=627c401d&scoped=true&"
import script from "./CurrentOrder.vue?vue&type=script&lang=js&"
export * from "./CurrentOrder.vue?vue&type=script&lang=js&"
import style0 from "./CurrentOrder.vue?vue&type=style&index=0&id=627c401d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c401d",
  null
  
)

export default component.exports